import { Warehouse } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import locations from './locations';

export interface CreateOrUpdateWarehouseForm {
    name: string
    addressLine1: string
    addressLine2: string
    addressLine3: string
    city: string
    stateProvince: string | null
    postalCode: string
    countryCode: string
    isResidential: boolean
    phoneNumber: string
}

interface WarehousesApiReturn {
    fetchWarehouses: () => Promise<Warehouse[]>
    fetchWarehouse: (warehouseId: number) => Promise<Warehouse>
    updateWarehouse: (warehouseId: number, form: CreateOrUpdateWarehouseForm) => Promise<void>
    createWarehouse: (form: CreateOrUpdateWarehouseForm) => Promise<void>
    deleteWarehouseAddress: (warehouseId: number, warehouseAddressId: number) => Promise<void>
    locations: ReturnType<typeof locations>
}

export default (axios: AxiosInstance = baseAxios): WarehousesApiReturn => ({
    fetchWarehouses: async (): Promise<Warehouse[]> => {
        const response = await axios.get<{ data: Warehouse[] }>('/api/warehouses');

        return response.data.data;
    },

    fetchWarehouse: async (warehouseId: number): Promise<Warehouse> => {
        const response = await axios.get<{ data: Warehouse }>(`/api/warehouses/${warehouseId}`);

        return response.data.data;
    },

    updateWarehouse: async (warehouseId: number, form: CreateOrUpdateWarehouseForm): Promise<void> => {
        await axios.put(`/api/warehouses/${warehouseId}`, {
            name: form.name,
            addressLine1: form.addressLine1,
            addressLine2: form.addressLine2,
            addressLine3: form.addressLine3,
            city: form.city,
            stateProvince: form.stateProvince,
            postalCode: form.postalCode,
            countryCode: form.countryCode,
            isResidential: form.isResidential,
            phoneNumber: form.phoneNumber,
        });
    },

    createWarehouse: async (form: CreateOrUpdateWarehouseForm): Promise<void> => {
        await axios.post('/api/warehouses', {
            name: form.name,
            addressLine1: form.addressLine1,
            addressLine2: form.addressLine2,
            addressLine3: form.addressLine3,
            city: form.city,
            stateProvince: form.stateProvince,
            postalCode: form.postalCode,
            countryCode: form.countryCode,
            isResidential: form.isResidential,
            phoneNumber: form.phoneNumber,
        });
    },

    deleteWarehouseAddress: async (warehouseId: number, warehouseAddressId: number): Promise<void> => {
        await axios.delete(`/api/warehouses/${warehouseId}/addresses/${warehouseAddressId}`);
    },

    locations: locations(axios),
});
